import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import intervalPlural from 'i18next-intervalplural-postprocessor';

// the translations
// (tip move them in a JSON file and import them)


const resources = {};

process.env.REACT_APP_POEDITOR_LANGUAGES.split(' ').map( lang => {
  resources[lang] = {
    translation: require(`./translations/${lang}.json`)
  }
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
    .use(intervalPlural)
  .init({
    fallbackLng: 'en',
    resources,
    debug: true,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
